package com.sweetlime.bingeamigo.model

data class NextEpisodeCardState(
    val tvShow: TvShow,
    val episodeToMark: LibraryEpisode,
    val episodeName: String,
    val seasonNumber: Int,
    val episodeNumber: Int,
    val totalThisSeason: Int,
    val watchedThisSeason: Int,
    val totalEpisodesInShow: Int,
    val airDate: String = "",
    val isMarking: Boolean = false
)